import { Button, Card, CardContent, CardHeader, CardTitle, FormField, Input } from "@jod/ui";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import type { FormEvent } from "react";
import { useState } from "react";
import { getOwnerPostAuthTarget, isOwnerAuthenticated, signInOwner } from "../lib/auth-session.ts";

export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    if (isOwnerAuthenticated()) throw redirect({ to: getOwnerPostAuthTarget() });
  },
  component: LoginScreen,
});

function LoginScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("owner@smokemirrors.example");
  const [password, setPassword] = useState("demo-password");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signInOwner(email, password);
      void navigate({ to: getOwnerPostAuthTarget() });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign in failed. Check your credentials.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="grid min-h-dvh place-items-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="font-display text-2xl">Owner Admin</CardTitle>
          <p className="text-muted-foreground text-sm">Backoffice dashboard · แดชบอร์ดเจ้าของร้าน</p>
        </CardHeader>
        <CardContent>
          <form className="space-y-4" onSubmit={(event) => void handleSubmit(event)}>
            <FormField id="email" label="Email / อีเมล">
              <Input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </FormField>
            <FormField id="password" label="Password / รหัสผ่าน">
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </FormField>
            {error ? (
              <p role="alert" className="rounded-md bg-destructive/10 p-3 text-destructive text-sm">
                {error}
              </p>
            ) : null}
            <Button type="submit" className="w-full" disabled={submitting}>
              {submitting ? "Signing in…" : "เข้าสู่ระบบ"}
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-full text-foreground"
              onClick={() => {
                setEmail("manager@smokemirrors.example");
                setPassword("demo-password");
              }}
            >
              Dev demo: manager
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
